export default __webpack_public_path__ + "static/media/airbnb.f1c40bbc.png";